<template>
  <div>
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>Termometria</el-breadcrumb-item>
          <el-breadcrumb-item>Orçamentos</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col :span="24">
        <h1>Orçamentos Termometria</h1>
      </el-col>
    </el-row>
    <el-row v-if="permissao.editar_termometria" type="flex" justify="left">
      <el-col :xs="24" :sm="24" :md="20" :lg="2" :xl="1">
        <h1>
          <router-link v-if="permissao.ler_termometria" to="/termometria/orcamento/criar">
            <el-button type="primary" icon="el-icon-circle-plus-outline">Novo</el-button>
          </router-link>
        </h1>
        <router-view />
      </el-col>
      <el-col :xs="24" :sm="24" :md="20" :lg="22" :xl="20">
<!-- 
        <el-form :inline="true" :model="formPesquisa" class="form-inline-pesquisa">
           <el-form-item label="">
            <el-input v-model="formPesquisa.pesquisa" placeholder="Pesquisa por...">
                  <el-button slot="append" @click="onSubmitPesquisa" icon="el-icon-search"></el-button>            
            </el-input>
          </el-form-item> 
        </el-form>
-->
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="24">
        <el-table
          :data="orcamentosTermometria"
          style="width: 100%"
          stripe
          v-loading="loading"
          element-loading-text="Loading..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
        >
<!-- 
        <el-table-column prop="id" label="Orçamento" width="120" sortable>
            <template v-slot="{ row }">
              <span>{{row.id.toString().padStart(6, "0") }}</span>
            </template>
          </el-table-column>
 -->
          <el-table-column prop="sge_cliente" label="Fabricante" width="105">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="getFabricanteTooltip(scope.row)"
                placement="top"
              >
                <span>{{ scope.row.sge_cliente }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="users_id" label="Vendedor" width="110">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="getUsuarioTooltip(scope.row)"
                placement="top"
              >
                <span>{{ scope.row.users_id }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="orcamento_base" label="Negócio" width="110" sortable></el-table-column>
          <el-table-column prop="orcamento_versao" label="Versão" width="80"></el-table-column>
          <el-table-column prop="cliente.nome" label="Cliente" width="350" sortable></el-table-column>
          <el-table-column label="Total sem IPI" width="120" align="right" header-align="right">
            <template v-slot="{ row }">
              <span>  {{formataDolarToReal(parseFloat(row.subtotal)) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="IPI" width="100" align="right" header-align="right">
            <template v-slot="{ row }">
              <span>  {{formataDolarToReal(parseFloat(row.ipi)) }}</span>
            </template>
          </el-table-column>
<!-- 
          <el-table-column label="Total" width="100" align="right" header-align="right">
            <template v-slot="{ row }">
              <span>  {{formataDolarToReal(parseFloat(row.total)) }}</span>
            </template>
          </el-table-column>
 -->
          <el-table-column prop="acao" label="Ação" width="110" filter-placement="bottom-end">
            <template slot-scope="scope">
              <el-button-group>
<!-- GERA O SCRIPT LATEX PARA DEBUGAR NO OVERLEAF
                <el-tooltip v-if="permissao.editar_termometria" class="item" effect="light" content="Imprimir" placement="top">
                  <el-button
                    size="mini"
                    type="info"
                    @click="gerarOrcamentoLatex(scope.row)"
                    icon="el-icon-printer"
                  ></el-button>
                </el-tooltip>                
-->
                <el-tooltip v-if="permissao.editar_termometria"  class="item" effect="light" content="Imprimir" placement="top">
                  <el-button
                    size="mini"
                    type="success"
                    @click="gerarRelatorioPdfModelo(scope.row)"
                    icon="el-icon-printer"
                  ></el-button>
                </el-tooltip>                
<!-- 
                <el-tooltip v-if="permissao.editar_termometria" class="item" effect="light" content="Nova Versão" placement="top">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="handleNovaVersao(scope.$index, scope.row)"
                    :disabled="scope.row.users_id != usuario"
                    icon="el-icon-document-copy"
                  ></el-button>
                </el-tooltip>                
 -->
                <el-tooltip v-if="permissao.editar_termometria" class="item" effect="light" content="Nova Versão" placement="top">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="handleNovaVersao(scope.$index, scope.row)"
                    icon="el-icon-document-copy"
                  ></el-button>
                </el-tooltip>                
<!-- DESATIVADO POR SEGURANÇA
                <el-tooltip v-if="permissao.excluir_termometria" class="item" effect="light" content="Excluir" placement="top">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                    icon="el-icon-delete"
                  ></el-button>
                </el-tooltip>
 -->
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next"
          background
          :total="total"
        ></el-pagination>
      </el-col>
    </el-row>

  </div>
</template>

<style>
.el-row-topo {
  margin-top: 10px;
}
</style>

<script>

import axios from "axios";
import FuncoesUteis from "../../plugins/FuncoesUteis";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  data() {
    return {
      loading: true,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      sortBy: 'id',
      sortOrder: 'desc',
      orcamentosTermometria: [],
      permissao: {},
      usuario: null,
      formPesquisa: {
        pesquisa: "",
      },
    };
  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.ler_termometria) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    this.usuario = FuncoesUteis.getUsuario();
    this.usuario = this.usuario.id_usuario || 0;

    // axios
    //   .get(url + "/termolist/", {
    //     headers: {
    //       Authorization: "Bearer " + this.$store.state.token,
    //     },
    //   })
    //   .then((response) => {
    //     if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
    //       this.$store.dispatch("logout").then(() => {
    //         this.$router.push("/login");
    //       });
    //     } else {
    //       this.total = response.data.length;
    //     }
    //   })
    //   .catch((err) => {
    //     this.total = "erro" + err;
    //   });

    // axios
    //   .get(url + "/termolist/0/" + this.pageSize, {
    //     headers: {
    //       Authorization: "Bearer " + this.$store.state.token,
    //     },
    //   })
    //   .then((response) => {
    //     this.itens = response.data;
    //     this.loading = false;
    //   })
    //   .catch((err) => {
    //     this.itens = "erro" + err;
    //   });
    this.getDados()
  },
  methods: {
    //LISTAR DADOS
    async getDados(paginaCorrente = 0, TamanhoPagina = "") {
      console.log('paginaCorrente',paginaCorrente)
      console.log('TamanhoPagina',TamanhoPagina)
      this.loading = true;
      try {
        const response = await axios.get(`${url}/termometria-orcamento-paginado?page=${this.currentPage}&perPage=${this.pageSize}&sortBy=${this.sortBy}&sortOrder=${this.sortOrder}`, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.orcamentosTermometria = response.data.data;
          // console.log("Orçamentos Termometria:", this.orcamentosTermometria);
          this.total = response.data.total;
        }
      } catch (err) {
        console.error("Erro ao buscar Orcamentos de Termometria:", err);
      } finally {
        this.loading = false;
      }





      // if (this.formPesquisa.pesquisa != "") {
      //   let dados = {
      //     pesquisa: this.formPesquisa.pesquisa,
      //   };
      //   axios
      //     .post(
      //       url + "/termosearch/" + paginaCorrente + "/" + this.pageSize,
      //       dados,
      //       {
      //         headers: {
      //           Authorization: "Bearer " + this.$store.state.token,
      //         },
      //       }
      //     )
      //     .then((response) => {
      //       this.itens = response.data.dados;
      //       this.total = response.data.total;
      //       this.currentPage = paginaCorrente;
      //     })
      //     .catch((err) => {
      //       this.itens = "erro" + err;
      //     });
      // } else {
      //   if (!TamanhoPagina) {
      //     TamanhoPagina = this.pageSize;
      //   }
      //   axios
      //     .get(url + "/termolist/" + paginaCorrente + "/" + TamanhoPagina, {
      //       headers: {
      //         Authorization: "Bearer " + this.$store.state.token,
      //       },
      //     })
      //     .then((response) => {
      //       this.itens = response.data;
      //     })
      //     .catch((err) => {
      //       this.itens = "erro" + err;
      //     });
      // }
    },
    




    //PESQUISA
    onSubmitPesquisa() {
      this.loading = true;
      let dados = {
        pesquisa: this.formPesquisa.pesquisa,
      };
      axios
        .post(url + "/userssearch/0/" + this.pageSize, dados, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          this.orcamentosTermometria = response.data.dados;
          this.total = response.data.total;
          this.currentPage = 1;
          this.loading = false;
        })
        .catch((err) => {
          this.orcamentosTermometria = "erro" + err;
        });
    },
    //FIM PESQUISA
    //PAGINAÇÃO
    handleSizeChange: function (size) {
      this.pageSize = size;
      let comeca_em;
      if (this.currentPage == 1) {
        comeca_em = 0;
      } else {
        comeca_em = (this.currentPage - 1) * this.pageSize;
      }
      this.getDados(comeca_em, this.pageSize);
    },
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      let comeca_em;
      if (currentPage == 1) {
        comeca_em = 0;
      } else {
        comeca_em = (currentPage - 1) * this.pageSize;
      }
      this.getDados(comeca_em, this.pageSize);
    },

    //FIM PAGINAÇÃO
    //FIM LISTAR DADOS
    handleEdit(index, row) {
      this.$router.push({ name: "termometriaCadastroNovaVersao", params: { id: row.id } });
    },
    handleNovaVersao(index, row) {
      this.$router.push({ name: "termometria-orcamento-duplicar", params: { id: row.id } });
    },
    handleNovaVersao2(index, row) {
      this.$router.push({ name: "termometria-orcamento-duplicar", params: { id: row.id } });
    },
    async gerarRelatorioPdfModelo(row) {
      const id = row.id
      try {
        this.loading = true;
        // console.log('gerarRelatorioPdfModelo', row)
        const response = await axios.post(
          url + '/termometria-orcamento-relatorio-pdf-modelo-2',
          { id: id, userId: row.users_id },
          {
            headers: { Authorization: "Bearer " + this.$store.state.token },
            responseType: 'blob',
          }
        );

        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
          return;
        }
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const numeroOrcamento = row.orcamento_base;
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `Proposta_${numeroOrcamento}.pdf`;
        link.click();
        this.$message.success('Relatório PDF gerado com sucesso!');
      } catch (error) {
        this.$message.error('Erro ao gerar o PDF (2): ' + (error.response?.data?.message || error.message));
      } finally {
        this.loading = false;
      }
    },
    async gerarOrcamentoLatex(row) {
      const id = row.id
      try {
        this.loading = true;
        const response = await axios.post(
          url + '/termometria-orcamento-latex',
          { id: id },
          {
            headers: { Authorization: "Bearer " + this.$store.state.token },
            responseType: 'blob', // Para lidar com o arquivo
          }
        );

        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
          return;
        }

        // Cria o Blob e força o download
        const blob = new Blob([response.data], { type: 'text/x-tex' });
        //const numeroOrcamento = this.gerarNumeroOrcamento();
        
        const numeroOrcamento = this.orcamentosTermometria.orcamento_base+this.orcamentosTermometria.orcamento_versao
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        // console.log('numeroOrcamento', numeroOrcamento)
        link.download = `Proposta_${numeroOrcamento}.tex`;
        link.click();

        this.$message.success('Arquivo LaTeX gerado com sucesso!');
      } catch (error) {
        this.$message.error('Erro ao gerar o arquivo LaTeX: ' + (error.response?.data?.message || error.message));
      } finally {
        this.loading = false;
      }
    },

    handleDelete(index, row) {
      this.$confirm("Tem certeza que deseja excluir este registro?", "Aviso", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(() => {
          axios
            .delete(url + "/termometria-orcamento-deletar/" + row.id, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then(() => {
              //this.itens = response.data;
              this.$notify({
                title: "Sucesso",
                message: "Registro excluído com Sucesso!",
                type: "success",
              });
              this.getDados();
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao excluir os dados! Tente novamente mais tarde!" + err,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    formataDolarToReal(valor,casasDecimais = 2) {
      if (isNaN(valor) || valor === null) return "0,00";
      let val = new String(valor.toFixed(casasDecimais));
      val = val.replace(",","");
      val = val.replace(".","");
      let tmp = val+'';
      tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
      if( tmp.length > 6 )
          tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
      return tmp;
    },
    getFabricanteTooltip(row) {
      return row.fabricante?.razao_social || '—';
    },
    getUsuarioTooltip(row) {
      return row.usuario?.nome || '—';
    },

  },
};
</script>
<style>
.form-inline-pesquisa {
  margin-top: 15px;
  text-align: left;
  padding-left: 50px;
}
</style>
